import { ArrowRight, CalendarDays, DollarSign, Megaphone, School, Mail  } from "lucide-react";

const audienceCards = [
    "Principal",
    "Counselor",
    "Teacher",
    "District Leader",
];

export default function SchoolsCTA() {
    return (
        <section
            id="request-demo"
            className="relative overflow-hidden bg-gradient-to-br from-[#f8f4ea] via-[#fff2cf] to-[#f7d7e8] px-6 py-16 lg:px-8"
        >
            {/* Final CTA background image placeholder */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-15"
                style={{
                    backgroundImage: "url('/assets/schools/school-cta-bg.png')",
                }}
            />

            <div className="absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.08)_1px,transparent_1px)] [background-size:14px_14px] opacity-40" />

            <div className="relative mx-auto max-w-5xl">
                <section className="rounded-[30px] border-[5px] border-black bg-white p-6 text-center shadow-[10px_10px_0_#000] md:p-10">
                    <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full border-[4px] border-black bg-[#ff3366] text-white shadow-[4px_4px_0_#000]">
                        <School size={32} strokeWidth={3} />
                    </div>

                    <h2 className="text-4xl font-black uppercase leading-none md:text-6xl">
                        Bring It to
                        <span className="block text-[#16bdf4] drop-shadow-[3px_3px_0_#000]">
                            Your School
                        </span>
                    </h2>

                    <p className="mx-auto mt-5 max-w-2xl text-base font-bold leading-8 md:text-lg">
                        Whether you’re a principal, counselor, teacher, or district
                        leader, you can introduce Call It Out quickly and effectively.
                    </p>

                    {/* <div className="mx-auto mt-6 grid max-w-3xl gap-3 sm:grid-cols-2 md:grid-cols-4">
                        {audienceCards.map((audience) => (
                            <div
                                key={audience}
                                className="rounded-[14px] border-[3px] border-black bg-[#f8f4ea] px-3 py-3 text-sm font-black uppercase shadow-[3px_3px_0_#000]"
                            >
                                {audience}
                            </div>
                        ))}
                    </div> */}

                    <div className="mt-8 flex flex-col items-center justify-center gap-3 lg:flex-row">
                        <a
                            href="mailto:playtohealgames@gmail.com?subject=Call%20It%20Out%20Demo%20Request&body=Hi,%20I’m%20interested%20in%20bringing%20Call%20It%20Out%20to%20my%20school.%20Please%20share%20more%20details."
                            className="inline-flex w-full items-center justify-center gap-2 rounded-md border-[3px] border-black bg-[#ffbc00] px-5 py-3 text-sm font-black uppercase text-black shadow-[5px_5px_0_#000] transition hover:-translate-y-1 hover:shadow-[7px_7px_0_#000] sm:w-auto"
                        >
                            Request School Info 
                            <Mail size={18} strokeWidth={3} />
                        </a>

                        {/* <a
                            href="#pricing"
                            className="inline-flex w-full items-center justify-center gap-2 rounded-md border-[3px] border-black bg-white px-5 py-3 text-sm font-black uppercase text-black shadow-[5px_5px_0_#000] transition hover:-translate-y-1 hover:shadow-[7px_7px_0_#000] sm:w-auto"
                        >
                            Get Pricing & School Packages
                            <DollarSign size={18} strokeWidth={3} />
                        </a> */}

                        <a
                            href="https://humanityrising.org/2026-rise-up-challenge/"
                            className="inline-flex w-full items-center justify-center gap-2 rounded-md border-[3px] border-black bg-[#ff3366] px-5 py-3 text-sm font-black uppercase text-white shadow-[5px_5px_0_#000] transition hover:-translate-y-1 hover:shadow-[7px_7px_0_#000] sm:w-auto"
                        >
                            Start the Call It Out Challenge
                            <Megaphone size={18} strokeWidth={3} />
                        </a>
                    </div>
                </section>

                <div className="mx-auto mt-8 max-w-3xl rotate-[-1deg] rounded-[20px] border-[4px] border-black bg-[#16bdf4] p-5 text-center shadow-[7px_7px_0_#000]">
                    <p className="text-xl font-black uppercase leading-tight text-white drop-shadow-[2px_2px_0_#000]">
                        Help students practice the conversations that change school culture.
                    </p>
                </div>
            </div>
        </section>
    );
}